import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { clientBadgesService } from '@/services/client-badges.service';
import { ClientBadgesState } from '@/types/updates-hub';

interface ClientBadgesStoreState {
  byClientId: Record<number, ClientBadgesState>;
}

const initialState: ClientBadgesStoreState = {
  byClientId: {},
};

export const fetchClientBadges = createAsyncThunk(
  'clientBadges/fetch',
  async (clientId: number, { rejectWithValue }) => {
    try {
      const badges = await clientBadgesService.getClientBadges(clientId);
      return { clientId, badges };
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch client badges');
    }
  }
);

const clientBadgesSlice = createSlice({
  name: 'clientBadges',
  initialState,
  reducers: {
    setClientBadges: (
      state,
      action: PayloadAction<{ clientId: number; badges: ClientBadgesState }>
    ) => {
      state.byClientId[action.payload.clientId] = action.payload.badges;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClientBadges.fulfilled, (state, action) => {
      state.byClientId[action.payload.clientId] = action.payload.badges;
    });
  },
});

export const { setClientBadges } = clientBadgesSlice.actions;
export default clientBadgesSlice.reducer;
